import { Plans } from "../../../../types/global";
import { plans } from "../../static/plans";

export default (plan?: Plans) => plans.find(p => p.name === plan)